import newLoader from 'assets/icons/new-loader.svg'
import whiteLoader from 'assets/icons/white-loader.svg'
import Loader from 'components/shared/Loader'
import { CalendarBox } from './styles'

export const CalendarLoader = ({ hasDarkMode }: { hasDarkMode?: boolean }) => (
    <CalendarBox bgColor={hasDarkMode ? 'darkmode_900' : 'grayscale_0'}>
        <Loader src={hasDarkMode ? whiteLoader : newLoader} />
    </CalendarBox>
)
